var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.contentWidth === 'boxed' ? 'container p-0' : null},[_c('router-view'),_c('footer',{staticClass:"footer footer-light footer-static"},[_vm._t("footer",function(){return [_c('app-footer')]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }